export const influencerPageUrl = 'https://www.insightiq.ai/creator-search-micro-app';
export const homePageUrl = 'https://www.insightiq.ai/';
const prefix = 'data';
const inputPrefix = `input`;
const label = `filter-label`;
const phrase = `phrase`;
export const SELECTORS = {
  // influencer filters
  ageFrom: `[${prefix}="age_from"]`,
  ageTo: `[${prefix}="age_to"]`,
  ageDD: `[${label}="age"]`,
  gender: `[${prefix}="gender"]`,
  genderDD: `[${label}="gender"]`,
  language: `[${prefix}="language"]`,
  languageDD: `[${label}="language"]`,
  location: `[${prefix}="location"]`,
  locationDD: `[${label}="location"]`,
  platform: 'input[name="filters"]:checked',
  findForm: `[${prefix}="find_form"]`,
  findButton: `[${prefix}="find_btn"]`,
  findSuccess: `[${prefix}="find_success"]`,
  noRecords: `[${prefix}="no-record"]`,
  internalError: `[${prefix}="internal-error"]`,
  loader: `[${prefix}="loader"]`,
  inputElements: `[${inputPrefix}="select"]`,
  audienceLocationValue: `[${prefix}="location-value"]`,
  resultAudienceLocation: `[${prefix}="result-location"]`,

  // audience filters
  audienceLocation: `[${prefix}="location-aud"]`,
  audienceLocationDD: `[${label}="location-aud"]`,
  audienceLocationPercentage: `[${prefix}="location-percentage"]`,
  audienceLocationPercentagePhrase: `[${phrase}="location-aud"]`,
  audienceLanguage: `[${prefix}="language-aud"]`,
  audienceLanguageDD: `[${label} = "language-aud"]`,
  audienceLanguagePercentage: `[${prefix}="language-percentage"]`,
  audienceLanguagePercentagePhrase: `[${phrase}="language-aud"]`,
  audienceGender: `[${prefix}="gender-aud"]`,
  audienceGenderDD: `[${label}="gender-aud"]`,
  audienceGenderPercentage: `[${prefix}="gender-percentage"]`,
  audienceGenderPercentagePhrase: `[${phrase}="gender-aud"]`,
  audienceAgeFrom: `[${prefix}="age_from-aud"]`,
  audienceAgeTo: `[${prefix}="age_to-aud"]`,
  audienceAgeDD: `[${label}="age-aud"]`,
  audienceAgePercentage: `[${prefix}="age-percentage"]`,

  // creator list page
  creatorList: `[${prefix}="creator-list"]`,
  creatorItem: `[${prefix}="creator-item"]`,
  creatorImage: `[${prefix}="creator-image"]`,
  creatorUsername: `[${prefix}="creator-username"]`,
  creatorName: `[${prefix}="creator-name"]`,
  creatorFollowers: `[${prefix}="creator-followers"]`,
  creatorLikes: `[${prefix}="creator-likes"]`,
  creatorEngagement: `[${prefix}="creator-engagement"]`,
  creatorLocationPercentage: `[${prefix}="creator-location-percentage"]`,
  creatorTotal: `[${prefix}="creator-total"]`,
  isVerified: `[${prefix}="verified"]`,
  errorLabel: `[${prefix}="error-label"]`,
};

export const LOCATION_ID_MAP = {
  default: 'Location',
  '173fbb5a-9749-4ec1-8246-889a9610522f': 'Afghanistan',
  'ec5857a0-387c-4651-a0da-a4eaa4b3da91': 'Australia',
  '1b4ea428-8d5b-4afe-8882-4b179f03155f': 'Belgium',
  '2b1c7fe1-534e-49da-9d28-5cf26264242f': 'Brazil',
  'a103500f-9270-4551-88fa-1aad977f454a': 'Canada',
  'f0dd060a-3f58-42bf-a352-2128e6ed83a7': 'Chile',
  'dde805bf-cc0d-4c54-b24d-8002d23bc81a': 'Colombia',
  'ef916294-473f-4cc3-b486-d7708bcc2d4d': 'Comoros',
  '8fd1ae5e-87c9-4654-b57d-3d6238d1b0fe': 'India',
  'c45fcbae-6c12-4db2-973f-8bf681623236': 'Italy',
  'cb8c4bd2-7661-4761-971a-c27322e2f209': 'United States',
};

export const LANGUAGE_CODE_MAP = {
  default: 'Language',
  en: 'English',
  es: 'Spanish',
  pt: 'Portuguese',
  fr: 'French',
};

export const GENDER_MAP = {
  default: 'Gender',
  ANY: 'Any',
  MALE: 'Male',
  FEMALE: 'Female',
};
